import { Switch } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

import classNames from "../../utils/classNames";

interface SellAVehicleStepProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
}

const benefits = [
  "Your prices are shown to sellers on scrapvehicle.co.uk alongside other local yards.",
  "Leads land straight in your dashboard with the seller's details and vehicle information.",
  "You only pay when a seller accepts your quote — £30 per lead, no monthly fee.",
  "Switch it off at any time from Admin Settings.",
];

export default function SellAVehicleStep({ enabled, onChange }: SellAVehicleStepProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Get more cars through scrapvehicle.co.uk</h2>
        <p className="mt-1 text-sm text-gray-600">
          SellAVehicle is our marketplace where the public compare scrap and salvage quotes. Turn it on to have
          your coverage area and prices quoted to sellers near you.
        </p>
      </div>

      <ul className="space-y-2">
        {benefits.map((b) => (
          <li key={b} className="flex items-start gap-2 text-sm text-gray-700">
            <CheckCircleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-primary-600" aria-hidden="true" />
            <span>{b}</span>
          </li>
        ))}
      </ul>

      <Switch.Group as="div" className="flex items-center gap-4 rounded-lg border border-gray-200 p-4">
        <Switch
          checked={enabled}
          onChange={onChange}
          className={classNames(
            enabled ? "bg-primary-600" : "bg-gray-200",
            "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          )}
        >
          <span
            aria-hidden="true"
            className={classNames(
              enabled ? "translate-x-5" : "translate-x-0",
              "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
            )}
          />
        </Switch>
        <Switch.Label className="text-sm">
          <span className="font-medium text-gray-900">
            {enabled ? "Yes — quote my prices on scrapvehicle.co.uk" : "Not right now"}
          </span>
          {enabled && <span className="block text-xs text-gray-500">£30.00 per accepted lead</span>}
        </Switch.Label>
      </Switch.Group>
    </div>
  );
}
